"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternAppBar = InternAppBar;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _commons = require("@focaltec-suite/commons");
var _AccountButton = require("./AccountButton");
var _AccessesButton = require("./AccessesButton");
var _AppsButton = require("./AppsButton");
var _MenuButton = require("./MenuButton");
var _NotificationsButton = _interopRequireDefault(require("../notifications/NotificationsButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CustomAppBar = (0, _styles.styled)(_material.AppBar)(function (_ref) {
  var theme = _ref.theme;
  return {
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: "0px 2px 5px 1px ".concat(theme.palette.divider),
    backgroundColor: theme.palette.background.paper
  };
});
function InternAppBar(_ref2) {
  var appId = _ref2.appId,
    email = _ref2.email,
    onSignOut = _ref2.onSignOut;
  return /*#__PURE__*/_react["default"].createElement(CustomAppBar, {
    position: "fixed",
    color: "inherit"
  }, /*#__PURE__*/_react["default"].createElement(_material.Toolbar, {
    variant: "dense",
    disableGutters: false
  }, /*#__PURE__*/_react["default"].createElement(_MenuButton.MenuButton, null), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      minWidth: {
        xs: '100px',
        md: '205px'
      },
      pr: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_commons.Logo, {
    text: (0, _core.translate)("apps.".concat(appId))
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      flexGrow: 1
    }
  }), /*#__PURE__*/_react["default"].createElement(_AccessesButton.AccessesButton, {
    appId: appId
  }), /*#__PURE__*/_react["default"].createElement(_NotificationsButton["default"], null), /*#__PURE__*/_react["default"].createElement(_AppsButton.AppsButton, null), /*#__PURE__*/_react["default"].createElement(_AccountButton.AccountButton, {
    email: email,
    onSignOut: onSignOut
  })));
}